import { render } from "./VersionSelectionModal.vue?vue&type=template&id=d81d3f66&scoped=true"
import script from "./VersionSelectionModal.vue?vue&type=script&lang=js"
export * from "./VersionSelectionModal.vue?vue&type=script&lang=js"

import "./VersionSelectionModal.vue?vue&type=style&index=0&id=d81d3f66&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81d3f66"]])

export default __exports__